var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3191_111260)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.9971,
    cy: 20,
    r: 18,
    fill: "#FEF5E7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7247 11.4442L23.4845 14.9929C23.7245 15.4869 24.3644 15.9607 24.9044 16.0514L28.094 16.5857C30.1338 16.9285 30.6138 18.4206 29.1439 19.8925L26.6642 22.3927C26.2442 22.8161 26.0143 23.6327 26.1442 24.2175L26.8542 27.3125C27.4141 29.7623 26.1242 30.71 23.9745 29.4296L20.9848 27.6452C20.4449 27.3226 19.555 27.3226 19.005 27.6452L16.0153 29.4296C13.8756 30.71 12.5757 29.7522 13.1357 27.3125L13.8456 24.2175C13.9756 23.6327 13.7456 22.8161 13.3256 22.3927L10.8459 19.8925C9.38607 18.4206 9.85602 16.9285 11.8958 16.5857L15.0854 16.0514C15.6154 15.9607 16.2553 15.4869 16.4953 14.9929L18.2551 11.4442C19.215 9.51861 20.7748 9.51861 21.7247 11.4442Z",
    stroke: "#F49D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3191_111260",
    x: -0.00292969,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3191_111260"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.615686 0 0 0 0 0.105882 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3191_111260"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3191_111260",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2655d047.svg";
export { ForwardRef as ReactComponent };